import SaleCard from "./SaleCard";
const PopularSales = ({ data, isTrue }) => {
    return (
        <>
            <div>
                <h2 className="text-black text-2xl font-bold mt-4 md:text-3xl">{data.title}</h2>
                <div className={`${!isTrue ? "w-full xl:grid-cols-3" : "xl:grid-cols-4"} grid md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 mt-4`}>
                    {
                        data.items.map((item) => {
                            return (
                                <SaleCard isTrue={isTrue} data={item} key={item?.id} />
                            )
                        })
                    }
                </div>
            </div>
        </>
    )
}
export default PopularSales;